import React from "react";
import { useApp } from "../../context/AppContext";
import { LayoutDashboard, Receipt, Users, CreditCard, Bitcoin, TrendingUp, FileText, Shield, LogOut, Landmark, X, Cloud, CalendarDays, BarChart3 } from "lucide-react";

const ADMIN = [
  { group: "Overview", items: [{ key: "dashboard", label: "Dashboard", icon: LayoutDashboard }] },
  { group: "Finance", items: [{ key: "expenses", label: "Expenses", icon: Receipt }, { key: "crypto", label: "Crypto Portfolio", icon: Bitcoin }, { key: "prices", label: "Live Prices", icon: TrendingUp }, { key: "invoice", label: "Invoices", icon: Receipt }] },
  { group: "Team", items: [{ key: "team", label: "Team Members", icon: Users }, { key: "payroll", label: "Payroll", icon: CreditCard }, { key: "loans", label: "Loan Requests", icon: Landmark }] },
  { group: "HR", items: [{ key: "payslip", label: "Payslip", icon: FileText }, { key: "attendance", label: "Attendance", icon: CalendarDays }] },
  { group: "Reports", items: [{ key: "analytics", label: "Analytics & Reports", icon: BarChart3 }] },
  { group: "System", items: [{ key: "audit", label: "Audit Log", icon: FileText }, { key: "backup", label: "Backup", icon: Cloud }, { key: "security", label: "Security", icon: Shield }] },
];
const EMP = [
  { group: "Overview", items: [{ key: "dashboard", label: "Dashboard", icon: LayoutDashboard }] },
  { group: "Finance", items: [{ key: "expenses", label: "My Expenses", icon: Receipt }] },
  { group: "Requests", items: [{ key: "loans", label: "Loan Request", icon: Landmark }] },
  { group: "HR", items: [{ key: "payslip", label: "My Payslip", icon: FileText }, { key: "attendance", label: "Attendance", icon: CalendarDays }] },
];

function NavContent({ nav, activePage, onNav, currentUser, roleLabel, logout, mobile, onClose }) {
  return (
    <>
      <div className="sidebar-logo">
        <div className="logo-icon">FB</div>
        <div>
          <div className="logo-text">Fin<em>Board</em></div>
          <div className="logo-ver">v11.3</div>
        </div>
        {mobile && (
          <button onClick={onClose} style={{ marginLeft: "auto", background: "none", border: "none", color: "#64748B", cursor: "pointer", padding: 6, display: "flex", alignItems: "center" }}>
            <X size={18} />
          </button>
        )}
      </div>
      <nav className="sidebar-nav">
        {nav.map((g) => (
          <div key={g.group} className="nav-group">
            <div className="nav-group-label">{g.group}</div>
            {g.items.map((i) => (
              <div key={i.key} className={"nav-item" + (activePage === i.key ? " active" : "")} onClick={() => onNav(i.key)}>
                <i.icon size={18} />
                <span>{i.label}</span>
              </div>
            ))}
          </div>
        ))}
      </nav>
      <div className="sidebar-footer">
        <div className="user-profile">
          <div className="user-avatar">{currentUser ? currentUser.charAt(0) : "?"}</div>
          <div className="user-info">
            <div className="user-name">{currentUser}</div>
            <div className="user-role">{roleLabel}</div>
          </div>
        </div>
        <button className="logout-btn" onClick={logout}><LogOut size={16} /></button>
      </div>
    </>
  );
}

export default function Sidebar({ activePage, setActivePage, mobile }) {
  const { mode, currentUser, logout, sidebarOpen, setSidebarOpen } = useApp();
  const nav = mode === "admin" ? ADMIN : EMP;
  const roleLabel = mode === "admin" ? "Super Admin" : "Employee";

  const onNav = (key) => {
    setActivePage(key);
    if (mobile) setSidebarOpen(false);
  };
  const onClose = () => setSidebarOpen(false);

  const props = { nav, activePage, onNav, currentUser, roleLabel, logout, mobile, onClose };

  // DESKTOP — in normal document flow (not fixed!)
  if (!mobile) {
    return (
      <div className="sidebar" style={{ width: 260, flexShrink: 0, position: "relative" }}>
        <NavContent {...props} />
      </div>
    );
  }

  // MOBILE — fixed overlay
  return (
    <>
      {sidebarOpen && (
        <div
          onClick={onClose}
          style={{
            position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
            background: "rgba(0,0,0,.65)", zIndex: 998,
          }}
        />
      )}
      <div
        className="sidebar"
        style={{
          position: "fixed", top: 0, left: 0, bottom: 0,
          width: 260, zIndex: 999,
          transform: sidebarOpen ? "translateX(0)" : "translateX(-100%)",
          transition: "transform .25s ease",
        }}
      >
        <NavContent {...props} />
      </div>
    </>
  );
}
